const sifcopGuard = (to, from, next) => {
  const isDevMode = process.env.VUE_APP_VUE_MODE === "development";
  const isTesting = process.env.VUE_APP_BACKEND_ENVIRONMENT?.includes(
    "siistesting.electro3.com.ar"
  );

  if (!isDevMode && !isTesting) {
    return next("/acceso-denegado");
  }

  const tipoUsuario = localStorage.getItem("tipo usuario");
  if (tipoUsuario !== "Super User") {
    return next("/acceso-denegado");
  }

  return next();
};

export default sifcopGuard;
